export const sources = {
	avif: "__VITE_ASSET__DmNKQvbN__ 330w",
	webp: "__VITE_ASSET__BgHEdfuB__ 330w"
};
export const img = {
	src: "__VITE_ASSET__pu10y3AM__",
	w: 330,
	h: 169
};
export default {
	sources: sources,
	img: img
};
